
import React from 'react';
import { Progress } from "@/components/ui/progress";
import { Card } from "@/components/ui/card";
import { Loader } from "lucide-react";
import { useTranslation } from 'react-i18next';
import { Button } from "@/components/ui/button";

interface AnalysisProgressProps {
  seoProgress: number;
  backlinkProgress: number;
  isVisible: boolean;
  onCancel?: () => void;
}

export const AnalysisProgress: React.FC<AnalysisProgressProps> = ({
  seoProgress,
  backlinkProgress,
  isVisible,
  onCancel
}) => {
  const { t } = useTranslation();
  
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <Card className="w-96 p-6 space-y-4">
        <div className="flex items-center space-x-2">
          <Loader className="h-5 w-5 animate-spin" />
          <h3 className="text-lg font-semibold">{t('analysis.analyzingSitemap')}</h3>
        </div>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span>{t('analysis.urlAnalysis')}</span>
            <span>{seoProgress}%</span>
          </div>
          <Progress value={seoProgress} className="h-2" />
        </div>
        
        {backlinkProgress > 0 && (
          <div className="space-y-2">
            <div className="flex justify-between text-sm">
              <span>{t('analysis.additionalAnalysis')}</span>
              <span>{backlinkProgress}%</span>
            </div>
            <Progress value={backlinkProgress} className="h-2" />
          </div>
        )}
        
        {onCancel && (
          <div className="flex justify-end pt-2">
            <Button variant="outline" size="sm" onClick={onCancel}>
              {t('buttons.cancel')}
            </Button>
          </div>
        )}
      </Card>
    </div>
  );
};
